"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actualiseStatuses = exports.getAllStatuses = exports.actualiseUnlockedElements = exports.actualiseLockedElements = exports.getAncestors = exports.getDescendants = exports.BFS = exports.makeGraphFromData = exports.preprocessData = void 0;
let preprocessData = (params, moduleId) => {
    const preprocessedData = {};
    const moduleData = params.graph.graph;
    const objectives = moduleData[moduleId].subgroups[0];
    // Preprocess module info
    const initSSB = moduleData[moduleId].init_ssb[0];
    const initiallyOpenedObjectives = [];
    for (let idx = 0; idx < initSSB.length; idx++) {
        initiallyOpenedObjectives.push(objectives[initSSB[idx]]);
    }
    preprocessedData[moduleId] = {
        requirements: [],
        subgroups: initiallyOpenedObjectives,
    };
    const requirements = moduleData[moduleId].requirements[0];
    for (let obj of objectives) {
        preprocessedData[obj] = {
            subgroups: moduleData[obj].subgroups[0],
            requirements: [],
        };
        // Preprocess objective info
        if (requirements[obj]) {
            const objRequirements = requirements[obj];
            for (let [requiredObjectiveId, { lvl, sr }] of Object.entries(objRequirements)) {
                if (!moduleData[requiredObjectiveId]) {
                    console.error(`Objective ${requiredObjectiveId} not found in module data`);
                    continue;
                }
                for (let idx = 0; idx < lvl.length; idx++) {
                    const requiredLevel = lvl[idx];
                    preprocessedData[obj].requirements.push([
                        moduleData[requiredObjectiveId].subgroups[0][requiredLevel],
                        sr[idx],
                    ]);
                }
            }
        }
        // Preprocess activity info
        if (moduleData[obj].requirements) {
            const actRequirements = moduleData[obj].requirements[0];
            const actRequirementsKeys = Object.keys(actRequirements);
            for (let act of actRequirementsKeys) {
                preprocessedData[act] = { subgroups: [], requirements: [] };
                const thisActReq = actRequirements[act];
                for (let objRequired of Object.keys(thisActReq)) {
                    for (let index = 0; index < thisActReq[objRequired].lvl.length; index++) {
                        const requiredLevel = thisActReq[objRequired].lvl[index];
                        preprocessedData[act].requirements.push([
                            moduleData[objRequired].subgroups[0][requiredLevel],
                            thisActReq[objRequired].sr[index],
                        ]);
                    }
                }
            }
        }
        // to handle default prerequisite when nothing is defined in module config
        for (let i = 1; i < preprocessedData[obj].subgroups.length; i++) {
            if (!preprocessedData[preprocessedData[obj].subgroups[i]]) {
                preprocessedData[preprocessedData[obj].subgroups[i]] = {
                    subgroups: [],
                    requirements: [],
                };
                preprocessedData[preprocessedData[obj].subgroups[i]].requirements.push([
                    preprocessedData[obj].subgroups[i - 1],
                    0.75,
                ]);
            }
        }
    }
    return preprocessedData;
};
exports.preprocessData = preprocessData;
let makeGraphFromData = (params, idModule) => {
    const moduleData = params["graph"]["graph"];
    const preprocessedData = (0, exports.preprocessData)(params, idModule);
    var graph = {};
    for (let node of Object.keys(preprocessedData)) {
        if (node == idModule) {
            graph[node] = {
                parents: [],
                children: preprocessedData[idModule]["subgroups"],
                status: -1,
            };
        }
        else {
            const subgroups = preprocessedData[node]["subgroups"];
            if (subgroups.length != 0) {
                const initActIndices = moduleData[node]["init_ssb"][0];
                //const maxIdx = Math.max(initActIndices)
                var initAct = [];
                for (let ii = 0; ii < initActIndices.length; ii++) {
                    initAct.push(subgroups[initActIndices[ii]]);
                    //graph[moduleData[node]["subgroups"][0][initActIndices[ii]]] = {"children":[subgroups[maxIdx+1]],"parents":[node],"status":-1}
                    graph[subgroups[initActIndices[ii]]] = {
                        children: [],
                        parents: [node],
                        status: -1,
                    };
                }
                graph[node] = { children: initAct, parents: [], status: -1 };
                for (let j = 0; j < subgroups.length; j++) {
                    if (!graph[subgroups[j]]) {
                        graph[subgroups[j]] = { children: [], parents: [], status: -1 };
                    }
                }
            }
        }
    }
    for (let node of Object.keys(preprocessedData)) {
        if (node != idModule) {
            const subgroups = preprocessedData[node]["subgroups"];
            const requirements = preprocessedData[node]["requirements"];
            for (let j = 0; j < subgroups.length; j++) {
                if (!graph[subgroups[j]]) {
                    if (preprocessedData[subgroups[j]]) {
                        graph[subgroups[j]].unlockSuccessRate = [];
                        for (let req of preprocessedData[subgroups[j]].requirements) {
                            if (!graph[subgroups[j]].parents.includes(req[0]))
                                graph[subgroups[j]].parents.push(req[0]);
                            graph[subgroups[j]].unlockSuccessRate.push(req[1]);
                            if (!graph[req[0]].children.includes(subgroups[j]))
                                graph[req[0]].children.push(subgroups[j]);
                        }
                    }
                    else {
                        for (let k = 0; k < j; k++) {
                            if (graph[subgroups[k]].children.length === 0) {
                                graph[subgroups[k]].children.push(subgroups[j]);
                                graph[subgroups[j]].parents.push(subgroups[k]);
                            }
                        }
                    }
                }
            }
            //graph[subgroups[maxIdx+1]] = {"children":[subgroups[maxIdx+2]],"parents":initAct,"status":-1}
            //for (let i=maxIdx+2;i<subgroups.length-1;i++){
            //graph[subgroups[i]] = {"children": [subgroups[i+1]],"parents": [subgroups[i-1]],"status":-1}
            //}
            //graph[subgroups[subgroups.length-1]] = {"children":[],"parents":[subgroups[subgroups.length-2]],"status":-1}
            for (let j = 0; j < requirements.length; j++) {
                graph[requirements[j][0]]["children"].push(node);
                graph[node]["parents"].push(requirements[j][0]);
                if (!Object.keys(graph[node]).includes("unlockSuccessRate")) {
                    graph[node]["unlockSuccessRate"] = [];
                }
                graph[node]["unlockSuccessRate"].push(requirements[j][1]);
            }
        }
    }
    for (let initObj of preprocessedData[idModule]["subgroups"]) {
        graph[initObj]["parents"].push(idModule);
    }
    return graph;
};
exports.makeGraphFromData = makeGraphFromData;
let BFS = (graph, node) => {
    var queue = [node];
    var visited = [node];
    while (queue.length > 0) {
        var s = queue.pop();
        if (s) {
            for (let neighbour of graph[s]["children"]) {
                if (!visited.includes(neighbour)) {
                    visited.push(neighbour);
                    queue.push(neighbour);
                }
            }
        }
    }
    return visited;
};
exports.BFS = BFS;
let getDescendants = (graph, idNode) => {
    return (0, exports.BFS)(graph, idNode);
};
exports.getDescendants = getDescendants;
let getAncestors = (graph, idNode) => {
    let computedAncestors = new Map();
    return Array.from(getAncestorsTailRecursive(graph, idNode, computedAncestors, new Set()));
};
exports.getAncestors = getAncestors;
function getAncestorsTailRecursive(graph, idNode, computedAncestors, ancestors = new Set()) {
    // Base case: if the node has no parents, return a set with the node itself
    if (graph[idNode]["parents"].length == 0) {
        let singleSet = new Set(idNode);
        computedAncestors.set(idNode, singleSet);
        return singleSet;
    }
    // Loop in the graph. Returns and print an error
    if (ancestors.has(idNode)) {
        console.error("There is a loop in the graph containing the following learning_set ids", ancestors, idNode);
        computedAncestors.set(idNode, ancestors);
        return ancestors;
    }
    ancestors.add(idNode);
    for (const parent of graph[idNode]["parents"]) {
        if (!computedAncestors.has(parent)) {
            getAncestorsTailRecursive(graph, parent, computedAncestors, ancestors);
        }
        else {
            // If already computed, merge the ancestor set from the computed results
            computedAncestors
                .get(parent)
                .forEach((ancestor) => ancestors.add(ancestor));
        }
    }
    // Cache the result
    computedAncestors.set(idNode, ancestors);
    return ancestors;
}
let actualiseLockedElements = (graph, lockedElements) => {
    for (let ID of Object.keys(graph)) {
        if (lockedElements.includes(ID)) {
            graph[ID]["status"] = 3;
        }
    }
};
exports.actualiseLockedElements = actualiseLockedElements;
let actualiseUnlockedElements = (graph, unlockedElements) => {
    for (let ID of Object.keys(graph)) {
        if (unlockedElements.includes(ID)) {
            graph[ID]["status"] = -1;
        }
    }
};
exports.actualiseUnlockedElements = actualiseUnlockedElements;
let getAllStatuses = (graph) => {
    var statusDict = {};
    for (let node of Object.keys(graph)) {
        statusDict[node] = graph[node]["status"];
    }
    return statusDict;
};
exports.getAllStatuses = getAllStatuses;
let actualiseStatuses = (data, graph, ModuleDiag, idModule) => {
    const moduleData = data["config"]["ai"]["moduleConfig"][idModule];
    for (let ID of Object.keys(ModuleDiag["param_state"])) {
        if (ID != idModule) {
            const indexObj = moduleData[idModule]["subgroups"][0].indexOf(ID);
            graph[ID]["status"] = ModuleDiag["param_state"][idModule][0][indexObj];
            for (let i = 0; i < ModuleDiag["param_state"][ID][0].length; i++) {
                graph[moduleData[ID]["subgroups"][0][i]]["status"] =
                    ModuleDiag["param_state"][ID][0][i];
            }
        }
    }
};
exports.actualiseStatuses = actualiseStatuses;
